import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-04372664"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "feedback-content"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 0,
  class: "feedback-text"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "已提软件下架申请，相关审核结果将在", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "主界面进行展示，请及时查看", -1));
const _hoisted_6 = [_hoisted_4, _hoisted_5];
const _hoisted_7 = {
  key: 1,
  class: "feedback-text"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "已提软件申请，相关审核结果将在主界", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "面进行展示，请及时查看", -1));
const _hoisted_10 = [_hoisted_8, _hoisted_9];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_t_button = _resolveComponent("t-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    src: _ctx.bglist,
    alt: ""
  }, null, 8, _hoisted_2), _ctx.pageType == 'takedown' ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6)) : _createCommentVNode("", true), _ctx.pageType == 'applied' ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10)) : _createCommentVNode("", true), _createVNode(_component_t_button, {
    onClick: _ctx.goBack,
    style: {
      "width": "175px",
      "height": "40px"
    },
    theme: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode("返回")]),
    _: 1
  }, 8, ["onClick"])]);
}